import { useEffect, useState } from "react";
import { fetchData } from "../function/util";
import ProductList from "../components/ProductList";
const Accessories=()=>{
    const [data, setData] = useState([]);
    
    useEffect(()=>{
        fetchData("products", {category:"accessories"})
        .then((result) => {
            setData(result);
        })
        .catch((error) => {
            console.error('Error fetching data:', error)
        })
    }, []);
    return (
         <div className="main-content">
            <ProductList data={data.products} />
        </div>
    )
}
export default Accessories;